<template>
	<div class="about">
		<div class="pg-header">
			<div><label class="title">待复诊</label></div>
			<div class="algr">
				<div class="pg-nav">
					<i class="icon-home"></i>
					<span>预约复诊管理</span>|
					<span>待复诊</span>
				</div>
			</div>
		</div>

		<div class="collapse-wrap">
			<div class="search-bar">
				<el-form ref="form" label-width="120px">
					<div class="def-key">
						<label>姓名<el-input size="small" maxlength="6" style="width:80px" v-model.trim="filter.name"
								@keyup.enter.native="handleFilter(0, $event)"></el-input></label>
						<label>身份证号<el-input size="small" maxlength="18" style="width:150px"
								v-model.trim="filter.cardNum"
								@keyup.enter.native="handleFilter(1, $event)"></el-input></label>
						<label>复诊日期
							<el-date-picker size="small" :default-time="['00:00:00', '23:59:59']" style="width:220px"
								type="daterange" align="right" unlink-panels range-separator="至"
								start-placeholder="开始日期" end-placeholder="结束日期" v-model="filter.date"
								:picker-options="pickerOptions" @change="handleFilter(2, $event)"></el-date-picker>
						</label>
						<div style="display: inline-block;">来源
							<el-select size="small" filterable clearable placeholder="请选择"
								v-model="filter.datasources" @change="handleFilter(4, $event)">
								<el-option label="出院" :value="Number(2)"></el-option>
								<el-option label="门诊" :value="Number(1)"></el-option>
							</el-select>
						</div>
						</div>
					<div class="def-key">
						<label v-if="filter.datasources">
							{{
								filter.datasources?{1:'就诊',2:'出院'}[filter.datasources]:''
								}}日期
							<el-date-picker size="small" :default-time="['00:00:00', '23:59:59']" style="width:220px"
								type="daterange" align="right" unlink-panels range-separator="至"
								start-placeholder="开始日期" end-placeholder="结束日期" v-model="filter.outdate"
								:picker-options="pickerOptions" @change="handleFilter(2, $event)"></el-date-picker>
						</label>
						<div style="display: inline-block;">科室
							<el-select size="small" filterable clearable v-model="filter.departmentId" placeholder="请选择"
								@change="handleFilter(3, $event)">
								<el-option v-for="item in deptList" :key="item.id" :label="item.name"
									:value="item.id"></el-option>
							</el-select>
						</div>
						<label>备注
							<el-input size="small" maxlength="6" style="width:80px" v-model="filter.remark" @keyup.enter.native="handleFilter(4, $event)"></el-input>
						</label>
						<el-button class="flr" size="mini" icon="el-icon-search" round
							@click="handleFilter">搜索</el-button>
						<el-button class="btn-export flr" size="mini" round @click="exportReport"
							style="margin-right: 10px;"><i class="icon-export"></i>导出</el-button>
					</div>
				</el-form>
			</div>

			<div class="table-wrap">
				<el-table ref="multipleTable" header-cell-class-name="tab-cell" cell-class-name="tab-cell" border
					:data="list.data" v-loading="isLoading" @selection-change="selectionChange">
					<el-table-column prop="name" label="姓名" width="120">
						<template slot-scope="scope"><router-link class="noline" target="_blank"
								:to="{name: 'Patient/User', query: {patientId: scope.row.patientId, t: 3, fid: scope.row.recordId,datasources:scope.row.datasources, t2: 3}}"><span
									class="fc key"><i class="icon-fav small"
										v-if="scope.row.star == 1"></i>{{ scope.row.name }}</span></router-link></template>
					</el-table-column>

					<el-table-column prop="cardNum" label="身份证号" width="140"></el-table-column>
					<el-table-column label="性别" width="80">
						<template slot-scope="scope">
							<span v-if="scope.row.sex == 1">男</span>
							<span v-else>女</span>
						</template>
					</el-table-column>
					<el-table-column prop="age" label="年龄" width="80">
						<template slot-scope="scope">
							<span>{{scope.row.age}}岁</span>
						</template>
					</el-table-column>

					<el-table-column prop="outHospitalDiagnosisName" label="诊断" show-overflow-tooltip></el-table-column>
					<el-table-column prop="departmentName" label="科室" show-overflow-tooltip></el-table-column>
					<el-table-column prop="" label="来源" width="80" show-overflow-tooltip>
						<template slot-scope="scope">
							<span v-if="scope.row.datasources == 0">院中</span>
							<span v-if="scope.row.datasources == 1">门诊</span>
							<span v-if="scope.row.datasources == 2">出院</span>
						</template>
					</el-table-column>
					<el-table-column prop="appointmentDate" label="预约复诊日期" width="120"
						show-overflow-tooltip></el-table-column>
					<el-table-column prop="remark" label="备注" width="120" show-overflow-tooltip></el-table-column>
					<el-table-column prop="manualStateStr" label="人工提醒" width="120"
						show-overflow-tooltip></el-table-column>
					<el-table-column label="自动提醒" show-overflow-tooltip>
						<template slot-scope="scope">
							{{
								smsAutoState[scope.row.smsAutoState]
							}}
						</template>
					</el-table-column>

					<el-table-column prop="reviserName" label="操作人" width="120" show-overflow-tooltip></el-table-column>
					<el-table-column fixed="right" label="操作" width="100">
						<template slot-scope="scope">
							<div class="tab-action">
								<el-tooltip content="查看" placement="top" :enterable="false"><router-link target="_blank"
										:to="{name: 'Patient/User', query: {patientId: scope.row.patientId, t: 3, fid: scope.row.recordId,datasources:scope.row.datasources, t2: 3}}"><i
											class="icon-research"></i></router-link></el-tooltip>
							</div>
						</template>
					</el-table-column>
				</el-table>
				<div class="pagination">
					<el-row>
						<el-col :span="12">
							<div class="record">当前是第<span
									v-text="(filter.pageNumber-1)*filter.pageSize+1"></span>条至第<span
									v-text="Math.min(list.total, (filter.pageNumber - 1) * filter.pageSize + filter.pageSize)"></span>数据
							</div>
							<div class="record">总计<span v-text="list.total"></span>条记录</div>
						</el-col>
						<el-col :span="12" style="text-align: right;">
							<el-pagination :disabled="isLoading" layout="sizes, prev, pager, next"
								:page-sizes="[10, 20, 30, 40, 50, 60, 70, 80, 90, 100]" prev-text="上一页" next-text="下一页"
								:current-page="list.current" :page-size="filter.pageSize" :total="list.total"
								@size-change="handleSizeChange" @current-change="handleCurrentChange"></el-pagination>
						</el-col>
					</el-row>
				</div>
			</div>

		</div>

	</div>
</template>

<script>
	import api from '@/service/api.js';
	import utils from '@/service/utils';
	import mixin from '@/views/mixin';
	import dayjs from 'dayjs';

	export default {
		mixins: [mixin],
		data() {
			return {
				list: {
					current: 1,
					total: 0,
					pageSize: 0,
					data: null
				},
				filter: {
					name: '',
					cardNum: '',
					appointmentDateStart: '',
					appointmentDateEnd: '',
					departmentId: '',
					outHospitalDiagnosisName: '',
					returnVisitState: '0',
					date: [],
					pageNumber: 1,
					pageSize: 10,
					datasources:null,
					hospitalDateStart:'',
					hospitalDateEnd:''
				},
				deptList: []
			}
		},
		created() {
			let query = this.$route.query;
			this.filter.datasources=query.datasources?Number(query.datasources):'';

			if (query.date) {
				if(typeof query.date=='string'){
					this.filter.appointmentDateStart = dayjs(query.date).format('YYYY-MM-DD 00:00:00')
					this.filter.appointmentDateEnd = dayjs(query.date).format('YYYY-MM-DD 23:59:59');
					this.filter.date = [this.filter.appointmentDateStart, this.filter.appointmentDateEnd];
				}else{
					this.filter.appointmentDateStart = dayjs(query.date[0]).format('YYYY-MM-DD 00:00:00')
					this.filter.appointmentDateEnd = dayjs(query.date[1]).format('YYYY-MM-DD 23:59:59');
					this.filter.date = [this.filter.appointmentDateStart, this.filter.appointmentDateEnd];
				}
				
			}
			if(query.date2){
				this.filter.hospitalDateStart = dayjs(query.date2[0]).format('YYYY-MM-DD 00:00:00')
				this.filter.hospitalDateEnd = dayjs(query.date2[1]).format('YYYY-MM-DD 23:59:59');
				this.filter.outdate = [this.filter.hospitalDateStart, this.filter.hospitalDateEnd];
			}
			if (query.state) {
				this.filter.returnVisitState = query.state.toString();
			}
			if(query.depId){
				this.filter.departmentId=parseInt(query.depId);
			}
			this.loadList();
			// 获取 科室下拉
			api.getDeptDropdown({}).then((res) => {
				if (res.code == 1000 && res.data) {
					this.deptList = res.data;
				}
			})
		},
		methods: {
			async loadList() {
				this.isLoading = true;
				let res = await api.getSubsequentVisitList(this.filter);
				if (res.code == 500) {
					return this.$router.push({
						name: 'Login',
						query: {
							r: location.href
						}
					});
				}

				this.list.total = +res.total;
				this.list.current = this.filter.pageNumber;
				this.list.pageSize = Math.ceil(this.list.total / this.filter.pageSize);
				if (res.data) {
					res.data.forEach((item) => {
						item.appointmentDate = dayjs(item.appointmentDate).format('YYYY-MM-DD');
						item.cardNum = utils.hideIdCard(item.cardNum);
					})
					this.list.data = res.data;
				}
				this.isLoading = false;
			},
			// 终止随访
			async saveForm(item) {
				console.log('终止随访', item);
				let res;
				this.isLoading = true;
				res = await api.delSubsequentVisit({
					id: item.id
				});
				if (res.code != 1000) {
					this.isLoading = false;
					return this.$message.error(res.message);
				}
				this.$message.success('已取消');
				this.loadList();
			},
			handleTab() {
				// 切换列表类型
				this.loadList();
			},
			// 过滤条件 更改
			handleFilter(key) {
				switch (key) {
					case 2:
						if (this.filter.date) {
							this.filter.appointmentDateStart = dayjs(this.filter.date[0]).format('YYYY-MM-DD 00:00:00');
							this.filter.appointmentDateEnd = dayjs(this.filter.date[1]).format('YYYY-MM-DD 23:59:59');
						} else {
							this.filter.appointmentDateStart = '';
							this.filter.appointmentDateEnd = '';
						}
						break;
					case 3:
						if (this.filter.outdate) {
							this.filter.hospitalDateStart = dayjs(this.filter.outdate[0]).format('YYYY-MM-DD 00:00:00');
							this.filter.hospitalDateEnd = dayjs(this.filter.outdate[1]).format('YYYY-MM-DD 23:59:59');
						} else {
							this.filter.hospitalDateStart = '';
							this.filter.hospitalDateEnd = '';
						}
						break;
				}
				this.filter.pageNumber = 1;
				this.loadList();
			},
			handleSizeChange(v) {
				this.filter.pageSize = v;
				this.filter.pageNumber = 1;
				this.loadList();
			},
			handleCurrentChange(v) {
				this.filter.pageNumber = v;
				this.loadList();
			},
			exportReport() {
				this.filter.pageSize=this.list.total;
				let url = api.exportAppointmentReturnVisit2ByObject(this.filter);
				const tempLink = document.createElement('a');
				tempLink.style.display = 'none';
				tempLink.href = url;
				tempLink.target = '_blank';
				document.body.appendChild(tempLink);
				tempLink.click()
				document.body.removeChild(tempLink);
			this.filter.pageSize=10;

			}
		}
	}
</script>

<style lang="less" scoped>
	@import '@/assets/style/var';
</style>